<!-- @veltra/icons generated sha256:4f2ddc6bd4e5f2c2 gen:8 source:src/svg/normal/hourglass.svg -->
<script setup lang="ts">
defineOptions({ name: 'Hourglass' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="m8 7.116 3.822-3.169a.49.49 0 0 0 .178-.38V2.5H4v1.066a.49.49 0 0 0 .178.381zM3 4.034V2.5a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v1.534a.5.5 0 0 1-.179.384L8.5 8l4.321 3.582a.5.5 0 0 1 .179.384V13.5a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-1.534c0-.149.064-.288.179-.383L7.499 8 3.18 4.418A.5.5 0 0 1 3 4.034m1 8.4V13.5h8v-1.066a.49.49 0 0 0-.178-.381L8 8.884l-3.822 3.169a.49.49 0 0 0-.178.38"
    />
  </svg>
</template>
